import { css } from 'styled-components';

import Roboto900Woff from '../../public/fonts/Roboto/Roboto-Black.woff';
import Roboto900Woff2 from '../../public/fonts/Roboto/Roboto-Black.woff2';
import Roboto700Woff from '../../public/fonts/Roboto/Roboto-Bold.woff';
import Roboto700Woff2 from '../../public/fonts/Roboto/Roboto-Bold.woff2';
import Roboto500Woff from '../../public/fonts/Roboto/Roboto-Medium.woff';
import Roboto500Woff2 from '../../public/fonts/Roboto/Roboto-Medium.woff2';
import Roboto400Woff from '../../public/fonts/Roboto/Roboto-Regular.woff';
import Roboto400Woff2 from '../../public/fonts/Roboto/Roboto-Regular.woff2';

const Mixins = {
  fonts: css`
    @font-face {
      font-family: 'Roboto';
      font-weight: 900;
      font-style: normal;
      font-display: swap;
      src: local('Roboto Black'), url(${Roboto900Woff2}) format('woff2'),
        url(${Roboto900Woff}) format('woff');
    }
    @font-face {
      font-family: 'Roboto';
      font-weight: 700;
      font-style: normal;
      font-display: swap;
      src: local('Roboto Bold'), url(${Roboto700Woff2}) format('woff2'),
        url(${Roboto700Woff}) format('woff');
    }
    @font-face {
      font-family: 'Roboto';
      font-weight: 500;
      font-style: normal;
      font-display: swap;
      src: local('Roboto Medium'), url(${Roboto500Woff2}) format('woff2'),
        url(${Roboto500Woff}) format('woff');
    }
    @font-face {
      font-family: 'Roboto';
      font-weight: 400;
      font-style: normal;
      font-display: swap;
      src: local('Roboto'), url(${Roboto400Woff2}) format('woff2'),
        url(${Roboto400Woff}) format('woff');
    }
  `,
  h1: css`
    font-size: 24px;
  `,
  h2: css`
    font-size: 16px;
    font-weight: 700;
  `,
  h3: css`
    font-weight: 700;
  `,
  labelText: css`
    font-size: 16px;
  `,
  btnReset: css`
    border: 0;
    background-color: transparent;
    padding: 0;
    color: inherit;
    cursor: pointer;
  `,
  listReset: css`
    margin: 0;
    padding: 0;
    list-style: none;
  `,
  fieldsetReset: css`
    margin: 0;
    padding: 0;
    border: 0;
  `,
  visuallyHidden: css`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    border: 0;
    padding: 0;
    white-space: nowrap;
    clip-path: inset(100%);
    clip: rect(0 0 0 0);
    overflow: hidden;
  `,
  hideScrollBar: css`
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }
  `,
};

export default Mixins;
